import LegalLayout, { LegalSection } from "./LegalLayout";

const CONTACT_EMAIL = "genelee.pro@gmail.com";

/**
 * Terms of use.
 *
 * Deliberately short and specific. A wall of boilerplate copied from a
 * template would say things this product does not do, and the one section
 * that genuinely matters — that AI career advice can be wrong — would be
 * buried in it. It is first here for that reason.
 */
const SECTIONS: LegalSection[] = [
    {
        id: "ai-advice",
        title: "The advice comes from an AI, and can be wrong",
        body: (
            <>
                <p>
                    Replies are generated by a large language model. It can be
                    confidently mistaken — about the job market, about salaries,
                    about what a particular employer wants, and about your own
                    resume.
                </p>
                <p>
                    <strong>
                        Treat everything it says as a starting point to check,
                        not as professional careers, legal, financial or
                        migration advice.
                    </strong>{" "}
                    Decisions about your career are yours, and the consequences
                    of following a suggestion from this product rest with you.
                </p>
            </>
        ),
    },
    {
        id: "your-account",
        title: "Your account",
        body: (
            <ul>
                <li>
                    Give an email address you actually control; it is how you
                    get back in.
                </li>
                <li>
                    Keep your password to yourself. Anything done from your
                    account is treated as done by you.
                </li>
                <li>One account per person.</li>
                <li>You must be old enough to agree to this — 16 or over.</li>
            </ul>
        ),
    },
    {
        id: "what-not-to-upload",
        title: "What not to upload",
        body: (
            <>
                <p>
                    Upload your own resume and your own materials. Do not
                    upload:
                </p>
                <ul>
                    <li>
                        someone else&apos;s personal information without their
                        consent;
                    </li>
                    <li>
                        anything confidential to an employer, such as internal
                        documents;
                    </li>
                    <li>
                        anything unlawful, or material you do not have the right
                        to share.
                    </li>
                </ul>
                <p>
                    Do not use the product to generate content intended to
                    deceive an employer — a fabricated work history, for
                    instance. It is here to help you present real experience
                    well.
                </p>
            </>
        ),
    },
    {
        id: "availability",
        title: "Availability",
        body: (
            <p>
                This runs on free hosting. It may be slow to wake up, may be
                unavailable, and may change or stop entirely without notice.
                There is no uptime commitment.{" "}
                <strong>
                    Keep your own copy of any resume you upload — do not treat
                    this as a backup.
                </strong>
            </p>
        ),
    },
    {
        id: "your-content",
        title: "Your content",
        body: (
            <p>
                What you upload and write stays yours. You grant only what is
                needed to run the product: storing your files, and sending your
                messages and resume text to the AI provider so it can reply.
                That permission ends when you delete the content. See the{" "}
                <a href="/privacy">Privacy Policy</a> for what goes where.
            </p>
        ),
    },
    {
        id: "ending-it",
        title: "Ending it",
        body: (
            <p>
                You can stop using the product at any time and delete your
                content from within it. Accounts used to attack the service or
                abuse other people may be removed.
            </p>
        ),
    },
];

const Terms = () => (
    <LegalLayout
        eyebrow="Terms"
        title="Terms of Use"
        summary={
            <>
                CareerMate AI is a student project built as part of the JR
                Academy AI Engineering program. It is free, provided as is, and
                run by one person. Using it means accepting what follows —
                starting with the part that matters most.
            </>
        }
        updated="13 September 2026"
        sections={SECTIONS}
        contactEmail={CONTACT_EMAIL}
    />
);

export default Terms;
